import { useRecoilValue } from "recoil";
import { authenticationStateAtom } from "../../../App";

export const useAuth = () => {
  const { authenticated, loading } = useRecoilValue(authenticationStateAtom);

  return { authenticated, loading };
};
